import { TID } from '@/lib/testIds';

const expertise = [
  'Strategy Consulting',
  'Business Transformation',
  'Management Consulting',
  'Project Management Office',
  'AI & Digital Intelligence',
  'Systems Thinking',
  'Operating Model Design',
  'Family Business Advisory',
];

const industries = [
  { name: 'Manufacturing', code: 'IND / 01' },
  { name: 'Retail & Consumer Business', code: 'IND / 02' },
  { name: 'Hospitality & Leisure', code: 'IND / 03' },
  { name: 'Startups & Scale-ups', code: 'IND / 04' },
  { name: 'Healthcare', code: 'IND / 05' },
  { name: 'MSMEs & Growing Enterprises', code: 'IND / 06' },
  { name: 'Real Estate', code: 'IND / 07' },
  { name: 'Travel & Tourism', code: 'IND / 08' },
];

export default function Expertise() {
  return (
    <section className="py-24 md:py-32 border-t border-white/8">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div data-testid={TID.expertise}>
          <div className="grid grid-cols-12 gap-6 md:gap-10 items-end mb-10">
            <div className="col-span-12 md:col-span-8">
              <p className="eyebrow mb-6">Featured Expertise</p>
              <h2
                className="font-display font-semibold text-text tracking-tight leading-[1.02]"
                style={{ fontSize: 'clamp(32px, 4.4vw, 64px)' }}
              >
                What I&apos;m <span className="text-ember">known for.</span>
              </h2>
            </div>
          </div>
          <div className="flex flex-wrap gap-3">
            {expertise.map((tag) => (
              <span
                key={tag}
                className="inline-flex items-center gap-2 rounded-full border border-white/12 bg-white/[0.03] px-5 py-2.5 text-[13px] text-text/85 hover:border-ember/60 hover:text-text hover:bg-white/[0.06] transition-colors cursor-default"
              >
                <span className="h-1 w-1 rounded-full bg-ember" />
                {tag}
              </span>
            ))}
          </div>
        </div>

        <div data-testid={TID.industries} className="mt-24 md:mt-32">
          <div className="grid grid-cols-12 gap-6 md:gap-10 items-end mb-12">
            <div className="col-span-12 md:col-span-7">
              <p className="eyebrow mb-6">Industries</p>
              <h2
                className="font-display font-semibold text-text tracking-tight leading-[1.02]"
                style={{ fontSize: 'clamp(32px, 4.4vw, 64px)' }}
              >
                Industries I&apos;ve worked{' '}
                <span className="text-ember">across.</span>
              </h2>
            </div>
            <div className="col-span-12 md:col-span-5">
              <p className="max-w-md text-[15px] leading-relaxed text-text/75">
                Depth in a handful of industries where governance and
                execution translate directly into enterprise value.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
            {industries.map((ind) => (
              <div
                key={ind.name}
                className="group relative rounded-2xl border border-white/8 bg-ink-2 p-6 min-h-[140px] flex flex-col justify-between hover:border-ember/50 hover:bg-ink-3 transition-colors"
              >
                <span className="text-[10px] uppercase tracking-[0.28em] text-text-70">
                  {ind.code}
                </span>
                <span className="font-display font-semibold text-text text-xl md:text-2xl leading-tight">
                  {ind.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
